/**
 * Checks if an error is likely a network connectivity issue that shouldn't be reported to Sentry.
 */
export function isNetworkError(error: any): boolean {
    if (!error) return false;

    const message = error.message?.toLowerCase() || '';
    const code = error.code?.toLowerCase() || '';

    const networkIndicators = [
        'network',
        'fetch',
        'timeout',
        'connection',
        'offline',
        'unreachable',
        'dns',
        'socket',
        'abort',
    ];

    const hasNetworkKeyword = networkIndicators.some((indicator) =>
        message.includes(indicator) || code.includes(indicator)
    );

    const networkErrorCodes = [
        'network_error',
        'timeout',
        'connection_error',
        'fetch_error',
        'abort_error',
    ];

    const hasNetworkCode = networkErrorCodes.includes(code);
    const isOffline = typeof navigator !== 'undefined'
        && typeof navigator.onLine === 'boolean'
        && !navigator.onLine;

    return hasNetworkKeyword || hasNetworkCode || isOffline;
}
